<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <transition name="slideleft" mode="out-in">
          <PendingInvoiceStatusHistory v-if="showLogPendingInvoices" />
        </transition>
        <transition name="fade" mode="out-in">
          <div
            class="m-quick-sidebar-overlay"
            v-if="showLogPendingInvoices"
            @click="closeLog()"
          ></div
        ></transition>
        <transition name="slideleft" mode="out-in">
          <PendingInvoiceLogModal v-if="showPendingInvoiceJobLogs" />
        </transition>
        <transition name="fade" mode="out-in">
          <div
            class="m-quick-sidebar-overlay"
            v-if="showPendingInvoiceJobLogs"
            @click="closePendingJobLogs()"
          ></div
        ></transition>
        <PendingInvoiceStatusChange
          ref="modalComponent"
          @updateList="callData"
        ></PendingInvoiceStatusChange>
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Faturas Pendentes</h1>
                <button
                  class="btn btn-sm btn-primary"
                  type="button"
                  @click="openPendingJobLogs()"
                >
                  <i class="fal fa-cog"></i> Logs
                  <span
                    v-if="omieAlerts.pending > 0"
                    class="badge badge-danger ml-1"
                    title="Erros do processo não vistos"
                    >{{ formatAlertCount(omieAlerts.pending) }}</span
                  >
                </button>
              </div>
              <div
                id="alert"
                class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
                :class="alert.color"
                role="alert"
                v-if="alert.message"
              >
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="alert.message = ''"
                ></button>
                <i :class="alert.icon"></i> &nbsp;<strong>{{
                  alert.message
                }}</strong
                ><br />
                {{ alert.reason }}
              </div>
              <div></div>
            </div>
            <div class="page-amounts">
              <nav aria-label="...">
                <ul class="pagination pagination-md">
                  <li class="page-item" :class="{ selected: amount == 3 }">
                    <a
                      @click.prevent.stop="setAmountPerPage(3)"
                      class="page-link paginate"
                      >3</a
                    >
                  </li>
                  <li class="page-item" :class="{ selected: amount == 10 }">
                    <a
                      @click.prevent.stop="setAmountPerPage(10)"
                      class="page-link paginate"
                      >10</a
                    >
                  </li>
                  <li class="page-item" :class="{ selected: amount == 50 }">
                    <a
                      @click.prevent.stop="setAmountPerPage(50)"
                      class="page-link paginate"
                      >50</a
                    >
                  </li>
                  <li class="page-item" :class="{ selected: amount == 100 }">
                    <a
                      @click.prevent.stop="setAmountPerPage(100)"
                      class="page-link paginate"
                      >100</a
                    >
                  </li>
                  <li class="page-item" :class="{ selected: amount == 150 }">
                    <a
                      @click.prevent.stop="setAmountPerPage(150)"
                      class="page-link paginate"
                      >150</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
            <div class="paginator-info-top m-2">
              <span class="m--font-gray" v-if="data.from"
                >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total
                de {{ data.total }}.</span
              >
              <span class="m--font-gray" v-else
                >Nenhum item a ser exibido.</span
              >
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table
                  class="table table-striped- table-bordered table-hover table-checkable"
                >
                  <thead>
                    <tr>
                      <th
                        style="white-space: nowrap, width:70"
                        class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType == 'customer_id' }"
                        @click="sortCall('customer_id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'customer_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'customer_id' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType != 'customer_id'"
                        ></span>
                      </th>
                      <th
                        style="white-space: nowrap, width:100"
                        class="text-center align-middle pointer"
                      >
                        Cliente
                      </th>
                      <th
                        style="white-space: nowrap, width:100"
                        class="text-center align-middle pointer"
                      >
                        CNPJ/CPF
                      </th>
                      <th
                        tyle="white-space: nowrap, width:60"
                        class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType == 'forecast' }"
                        @click="sortCall('forecast')"
                      >
                        Previsão de pagamento
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'forecast' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'forecast' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType != 'forecast'"
                        ></span>
                      </th>
                      <th
                        tyle="white-space: nowrap, width:100"
                        class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType == 'invoice_value' }"
                        @click="sortCall('invoice_value')"
                      >
                        Valor
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'invoice_value' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'invoice_value' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType != 'invoice_value'"
                        ></span>
                      </th>
                      <th
                        tyle="white-space: nowrap, width:20"
                        class="text-center align-middle"
                      >
                        Bloqueio Manual
                      </th>
                      <th
                        tyle="white-space: nowrap, width:20"
                        class="text-center align-middle"
                      >
                        Pagamento Pendente
                      </th>
                      <th
                        tyle="white-space: nowrap, width:20"
                        class="text-center align-middle"
                      >
                        Ações
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.id"
                          v-b-tooltip.hover
                          title="Filtrar por ID do Cliente"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.name"
                          v-b-tooltip.hover
                          title="Filtrar por nome do Cliente"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.document"
                          v-b-tooltip.hover
                          title="Filtrar por CNPJ/CPF"
                        />
                      </td>
                      <td>
                        <SelectInvoicePendingMonth
                          :selected="filters.month"
                          @change="setFilter('month', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por mês de cobrança"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.price"
                          v-b-tooltip.hover
                          title="Filtrar por valor total"
                        />
                      </td>
                      <td>
                        <SelectYesNo
                          :selected="filters.block_manually"
                          :bool="true"
                          @change="setFilter('block_manually', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td>
                        <SelectYesNo
                          :selected="filters.pending"
                          :bool="true"
                          @change="setFilter('pending', $event)"
                          class="form-control-sm"
                        />
                      </td>

                      <td
                        class="text-center align-middle"
                        tyle="white-space: nowrap"
                      >
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-filter mr-1"
                          @click="callData"
                          v-b-tooltip.hover
                          title="Clique para filtrar"
                        >
                          <i class="far fa-search"></i> Filtrar
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-filter"
                          @click="clearFilters"
                          v-b-tooltip.hover
                          title="Clique para limpar os filtros"
                        >
                          <i class="far fa-eraser"></i> Limpar
                        </button>
                      </td>
                    </tr>
                    <tr v-for="(invoice, id) in data.data" :key="id">
                      <td class="text-center align-middle">
                        {{ invoice.customer ? invoice.customer.id : '-' }}
                      </td>
                      <td class="text-left align-middle">
                        {{
                          invoice.company
                            ? invoice.company.name
                            : invoice.customer && invoice.customer.customerable
                            ? invoice.customer.customerable.co_name ||
                              invoice.customer.customerable.name
                            : '-'
                        }}
                      </td>
                      <td class="text-left align-middle">
                        {{
                          invoice.company
                            ? invoice.company.cnpj
                            : (invoice.customer &&
                              invoice.customer.documents &&
                              invoice.customer.documents.value
                                ? invoice.customer.documents.value
                                : '-')
                              | cnpj
                              | cpf
                        }}
                      </td>
                      <td class="text-center align-middle">
                        {{ invoice.forecast | date }}
                      </td>
                      <td class="text-right align-middle">
                        {{ invoice.invoice_value | money }}
                      </td>
                      <td
                        tyle="white-space: nowrap"
                        class="text-center align-middle"
                      >
                        {{
                          invoice.customer
                            ? invoice.customer.block_manually
                              ? 'Sim'
                              : 'Não'
                            : '-'
                        }}
                      </td>
                      <td
                        tyle="white-space: nowrap"
                        class="text-center align-middle"
                      >
                        {{ invoice.pending ? 'Sim' : 'Não' }}
                      </td>
                      <td
                        style="white-space: nowrap"
                        class="text-center align-middle"
                      >
                        <div class="d-flex justify-content-center align-items-center">
                          <button
                            class="btn btn-sm btn-primary"
                            style="width: 100px"
                            type="button"
                            id="actionBlockCustomer"
                            @click="
                              toggleCustomerBlock(
                                invoice.customer,
                                invoice.customer
                                  ? invoice.customer.status == 1
                                    ? 'Bloquear Cliente'
                                    : 'Desbloquear Cliente'
                                  : 'Bloquear Cliente',
                                invoice.id
                              )
                            "
                            :disabled="!invoice.customer"
                          >
                            {{
                              invoice.customer
                                ? invoice.customer.status == 1
                                  ? 'Bloquear'
                                  : 'Desbloquear'
                                : 'Bloquear'
                            }}
                          </button>
                          <button
                            class="btn btn-sm btn-primary ml-2"
                            type="button"
                            id="logPendingInvoice"
                            :disabled="!invoice.customer"
                            @click.prevent.stop="showHistory(invoice)"
                          >
                            <i class="fas fa-history"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um
                  total de {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else
                  >Nenhum item a ser exibido.</span
                >
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 2"
                      >
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 1"
                      >
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">
                        {{ data.current_page }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 1"
                      >
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: data.current_page + 1 == data.last_page,
                      }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 2"
                      >
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectInvoicePendingMonth from '@/components/forms/SelectInvoicePendingMonth';
import PendingInvoiceStatusChange from '@/components/invoices/pending-invoices/PendingInvoiceStatusChange';
import SelectYesNo from '@/components/forms/SelectYesNo';
import PendingInvoiceStatusHistory from '@/components/invoices/pending-invoices/PendingInvoiceStatusHistory';
import PendingInvoiceLogModal from '@/components/invoices/pending-invoices/PendingInvoiceLogModal';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { omieAlertsMixin } from '@/mixins/omieAlertsMixin';
import { baseApiUrl } from '@/global';

import axios from 'axios';

export default {
  mixins: [returnMessageMixin, omieAlertsMixin],
  name: 'Invoices',
  components: {
    SelectInvoicePendingMonth,
    SelectYesNo,
    PendingInvoiceStatusChange,
    PendingInvoiceStatusHistory,
    PendingInvoiceLogModal,
  },
  data() {
    return {
      sortType: localStorage.invoicesPendingSortType
        ? localStorage.invoicesPendingSortType
        : 'forecast',
      sortReverse: localStorage.invoicesPendingSortReverse
        ? localStorage.invoicesPendingSortReverse
        : true,
      amount: localStorage.invoicesPendingDataAmount
        ? localStorage.invoicesPendingDataAmount
        : 50,
      page: localStorage.invoicesPendingDataPage
        ? localStorage.invoicesPendingDataPage
        : 1,
      filters: {
        id: localStorage.invoicesPendingFilterId
          ? localStorage.invoicesPendingFilterId
          : '',
        name: localStorage.invoicesPendingFilterName
          ? localStorage.invoicesPendingFilterName
          : '',
        document: localStorage.invoicesPendingDocumentName
          ? localStorage.invoicesPendingDocumentName
          : '',
        pending: localStorage.invoicesPendingFilterPending
          ? localStorage.invoicesPendingFilterPending
          : '',
        month: localStorage.invoicesPendingFilterMonth
          ? localStorage.invoicesPendingFilterMonth
          : '',
        price: localStorage.invoicesPendingFilterPrice
          ? localStorage.invoicesPendingFilterPrice
          : '',
        block_manually: localStorage.invoicesPendingBlockManually
          ? localStorage.invoicesPendingBlockManually
          : '',
      },
      data: [],
      dialog: '',
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showLogPendingInvoices() {
      return this.$store.state.showLogPendingInvoices;
    },
    showPendingInvoiceJobLogs() {
      return this.$store.state.showPendingInvoiceJobLogs;
    },
  },
  methods: {
    showHistory(pendingInvvoice) {
      this.$store.state.showLogPendingInvoices = pendingInvvoice;
    },
    closeLog() {
      this.$store.state.showLogPendingInvoices = null;
      this.callData();
    },
    openPendingJobLogs() {
      this.$store.state.showPendingInvoiceJobLogs = true;
    },
    closePendingJobLogs() {
      this.$store.state.showPendingInvoiceJobLogs = null;
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.document = '';
      this.filters.month = '';
      this.filters.price = '';
      this.filters.block_manually = '';
      this.filters.pending = '';
      this.filters.sortType = 'forecast';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('invoicesPendingFilterId', this.filters.id);
      localStorage.setItem('invoicesPendingFilterName', this.filters.name);
      localStorage.setItem(
        'invoicesPendingDocumentName',
        this.filters.document
      );
      localStorage.setItem('invoicesPendingFilterPrice', this.filters.price);
      localStorage.setItem(
        'invoicesPendingBlockManually',
        this.filters.block_manually
      );
      localStorage.setItem('invoicesPendingPending', this.filters.pending);
      localStorage.setItem('invoicesPendingDataAmount', this.amount);
      localStorage.setItem('invoicesPendingDataPage', this.page);
      localStorage.setItem('invoicesPendingSortType', this.sortType);
      localStorage.setItem('invoicesPendingSortReverse', this.sortReverse);
    },
    convertFilters() {
      return `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&document=${
        this.filters.document ? this.filters.document : ''
      }&month=${this.filters.month ? this.filters.month : ''}&price=${
        this.filters.price ? this.filters.price : ''
      }&amount=${this.amount}
      &sortType=${this.sortType}
      &sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}
      &pending=${this.filters.pending ? this.filters.pending : ''}
      &block_manually=${
        this.filters.block_manually ? this.filters.block_manually : ''
      }`;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    setAmountPerPage(amount) {
      this.amount = amount;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.invoiceIds = [];

        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/invoice/pending/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    toggleCustomerBlock(customer, title, pendingInvoiceId) {
      this.$refs.modalComponent.setContent(customer, title, pendingInvoiceId);
      this.$refs.modalComponent.openModal();
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    this.fetchOmieAlerts();
    window.scroll(0, 0);
  },
};
</script>
<style>
.bgPlan {
  background-color: rgba(250, 244, 251, 1);
}
.bgSpreadsheet {
  background-color: rgb(208, 255, 222);
}
</style>
